export default __webpack_public_path__ + "static/media/howtouse_basic_03_ko.9376d078.png";